<div fxLayout="column" fxFlex="grow" style="width:100%">

  <div fxLayout="row" fxFlex="grow" style="width:100%;">
    Ανάθεση επιπέδων για την δραστηριότητα {{activity.description}}
  </div>

  <div fxLayout="row" fxFlex="grow" style="width:100%;">
    <!--        Table     -->
    <table mat-table [dataSource]="levels" matSort style="width:100%;">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef fxFlex="10" fxLayoutAlign="start center center">
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" fxFlex="10" fxLayoutAlign="start center center">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="90" fxLayoutAlign="start center center"> Περιγραφή Επιπέδου
        </th>
        <td mat-cell *matCellDef="let level" fxFlex="90"
            fxLayoutAlign="start center center"> {{level.description}} </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let record; columns: displayColumns"></tr>
    </table>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center center" style="margin-top:5px;">
    <mat-paginator [length]="20" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]">
    </mat-paginator>
</div>

  <div fxLayout="row" fxLayoutAlign="end center center" style="margin-top:5px;">
   <button mat-raised-button (click)="assign()" [disabled]="selection.selected.length === 0" style="background-color: var(--primary); color: white;">Ανάθεση Επιλεγμένων</button>
  </div>
</div>
